import commonFunction from "../../lib/utils/common";

// Returns true when a redirect to /login was initiated, so callers can stop
// rendering protected content while the navigation is in flight (BYV-5136).
const loginB2B = ({ props }) => {
  try {
    const userToken = commonFunction.getCookieTocken("userToken") || "";
    const isB2B = props?.home?.data?.site?.business_b2b;
    const isLoginPage = window.location.pathname === "/login";

    if (isB2B && !userToken && !isLoginPage) {
      window.location.href = "/login";
      return true;
    }
    return false;
  } catch (error) {
    console.error("login b2b error", error);
    return false;
  }
};

export default loginB2B;
